module.exports = __webpack_public_path__ + "files/d3d8f0509086e5b3816e79100428aa6e.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/symbols-4.png
// module id = 530
// module chunks = 76